import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/styles.scss";

import Header from "./components/Header";
import Slider from "./components/Slider";
import Main from "./components/Main";
import Footer from "./components/Footer";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";
import PickupExperienceModal from "./components/PickupExperienceModal";

import Error404 from "./components/404";

import ScrollToTop from "./components/ScrollToTop";
import { getFirestore, getWithExpiry, setWithExpiry } from "./config/firebase";
import { AppProvider } from "./config/ToSendProvider";
import TagManager from "react-gtm-module";

function App() {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-WDDBKV7",
    };

    TagManager.initialize(tagManagerArgs);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarVehiculos = async () => {
      const datosLocales = getWithExpiry("vehicles");
      if (datosLocales) {
        setVehicles(datosLocales);
        setLoading(false);
      } else {
        const db = getFirestore();
        const vehicles = db.collection("ford");
        try {
          const querySnapshot = await vehicles.get();
          const vehiclesData = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          setWithExpiry("vehicles", vehiclesData);
          setVehicles(vehiclesData);
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      }
    };

    cargarVehiculos();
  }, []);

  return (
    <AppProvider>
      <Router basename="/ford">
        <ScrollToTop />
        <Switch>
          <Route exact path="/:tipo?">
            <Header vehicles={vehicles} loading={loading} />
            <Slider />
            <Main vehicles={vehicles} loading={loading} />
            <Footer />
            <WhatsAppFlotante />
            {/* <PickupExperienceModal /> */}
          </Route>

          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </Router>
    </AppProvider>
  );
}

export default App;

